import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAemConfig } from '@as-react/common-components';
import { uniqueId } from '@as-react/common-utils';
import { Carousel, CarouselVariant, ImageRadioButtonSize, Text, TextSize, ImageRadioButton, SliderNavVariant, } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateSwatchFromProductColor, getDiscountIconContent } from '../../../util/SwatchUtil';
import { Box } from '@yonderland/andes-react';
const SLIDE_WIDTH = 34;
const SLIDES_TO_SCROLL_CORRECTION = 3;
export const MiniPDPSwatchesCarousel = ({ colors, selectedColor, productCode, productImageCdnDomains, setProductColor, showTitle, boxProps = {
    paddingBlockStart: { md: '2' },
    paddingBlockEnd: { base: '3', md: '4' },
}, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { productSwatchConfig } = useAemConfig();
    const carouselId = useMemo(() => uniqueId(), []);
    const renderSlide = useCallback((colour, index) => {
        const key = `color_swatch_${carouselId}_${colour.colourId}_${index}`;
        return (_jsx("div", { children: _jsx(ImageRadioButton, { id: key, name: `color_swatch_${carouselId}`, value: colour.colourId.toString(), checked: colour.colourId === selectedColor.colourId, imageUrl: colour.swatch, imageLazyLoad: true, textOverlay: true, textImage: getDiscountIconContent(colour, productSwatchConfig), title: colour.color, onChange: () => setProductColor(colour.colourId), size: ImageRadioButtonSize.SMALL }) }, key));
    }, [colors, selectedColor, setProductColor]);
    const calculateSlidesToScroll = (slidesToScroll, swatches) => swatches && swatches.length - 1 === slidesToScroll ? slidesToScroll : slidesToScroll - SLIDES_TO_SCROLL_CORRECTION;
    function onSwiperInit() {
        const maxSlides = Math.floor(this.width / SLIDE_WIDTH);
        this.params.slidesPerView = maxSlides;
        this.navigation.update();
        this.update();
    }
    function onSwiperResize() {
        const maxSlides = Math.floor(this.width / SLIDE_WIDTH);
        if (this.params.slidesPerView !== maxSlides) {
            this.params.slidesPerView = maxSlides;
            this.navigation.update();
            this.update();
        }
    }
    const colorSwatches = colors.map(productColor => generateSwatchFromProductColor(productColor, selectedColor, productCode, productImageCdnDomains));
    const colorSwatchesSlideConfig = {
        variant: CarouselVariant.SWATCHES,
        arrowsConfig: {
            variant: SliderNavVariant.SWATCHES,
        },
        showPagination: false,
        configurationOverrides: {
            preventClicks: false,
            watchOverflow: true,
            slidesPerGroup: calculateSlidesToScroll(5, colorSwatches),
            spaceBetween: 0,
            shouldSwiperUpdate: true,
            noSwiping: false,
            allowTouchMove: false,
            on: {
                init: onSwiperInit,
                resize: onSwiperResize,
            },
        },
    };
    return showTitle ? (_jsxs(Box, Object.assign({}, boxProps, { children: [_jsxs(Box, { children: [_jsx(Text, { size: TextSize.SMALL, inline: true, emphasized: true, children: `${t('product:pdp.color')}: ` }), _jsx(Text, { size: TextSize.SMALL, inline: true, dataQA: "color_name", children: selectedColor.description })] }), colorSwatches && colorSwatches.length > 1 && (_jsx(Box, { paddingBlockStart: "1", children: _jsx(Carousel, Object.assign({}, colorSwatchesSlideConfig, { children: colorSwatches.map((image, index) => renderSlide(image, index)) })) }))] }))) : (colorSwatches && colorSwatches.length > 1 && (_jsx(Carousel, Object.assign({}, colorSwatchesSlideConfig, { children: colorSwatches.map((image, index) => renderSlide(image, index)) }))));
};
